import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_consolidated_arap_applet_catalog_link_RowClass} from '../../../dbschema';

export class ConsolidatedArapAppletCatalogLinkContainerModel extends BaseContainerModel {
  bl_fi_consolidated_arap_applet_catalog_link: bl_fi_consolidated_arap_applet_catalog_link_RowClass = new bl_fi_consolidated_arap_applet_catalog_link_RowClass();
}
